import { render, staticRenderFns } from "./StaffScheduling.vue?vue&type=template&id=9674deee&"
import script from "./StaffScheduling.vue?vue&type=script&lang=ts&"
export * from "./StaffScheduling.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports